import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
// @ts-igore
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
import MalSearchOption from '@/components/MalSearchOption.vue';
// 图片压缩（package.json 已安装：browser-image-compression ^2.0.2）
import imageCompression from 'browser-image-compression';
/**
 * 前端图片压缩工具（browser-image-compression）
 * 目标：最长边 1920px，JPEG quality=0.8，期望 ≤ 1MB
 */
async function compressImageFile(file) {
    const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
        initialQuality: 0.85,
    };
    // @ts-ignore browser-image-compression 类型定义有限，忽略 TS 检查
    const compressed = await imageCompression(file, options);
    if (compressed instanceof File)
        return compressed;
    // Blob → File，保留原文件名
    return new File([compressed], file.name || `compressed_${Date.now()}.jpg`, {
        type: compressed.type || 'image/jpeg',
    });
}
let DeviceLicense = class DeviceLicense extends Vue {
    constructor() {
        super();
        this.exportForm = {
            menuVisible: false,
            deviceTypeGroup: null,
            year: '',
            deviceType: '',
            serial: '',
        };
        this.menuSearch = false;
        this.showAdvancedSearch = false;
        this.snackbar = new CBcSnackbar();
        this.pageLoading = false;
        this.formValid = false;
        this.isExpanded = false;
        this.dialog = {
            editor: -1,
            title: '',
            text: '',
            visible: false,
            loading: false,
            detail: false,
            status: false,
        };
        this.listDevice = [];
        this.listHospital = [];
        this.list = [];
        this.listStatus = [];
        this.listCategories = [];
        this.listModules = [];
        this.listDates = [];
        this.exportDataMenu = [];
        this.windowHeight = window.innerHeight;
        this.windowWidth = window.innerWidth;
        this.tableHeight = 400;
        this.pageRef = null;
        this.toolbarRef = null;
        this.searchAreaRef = null;
        this.contentAreaRef = null;
        this.paginationRef = null;
        this.resizeObserver = null;
        //   deviceSerialInfo: any = {} //设备信息,导出excel 过滤使用
        this.searchTimer = null;
        this.userInfoDic = {
            list: [],
            value: undefined,
            loading: true,
        };
        // 故障附件相关
        this.attachImageFile = null;
        this.attachPreviewList = [];
        this.attachIdList = [];
        this.attachUploadAccept = 'image/*,video/*,.mp4,.webm,.mov,.avi';
        this.attachMaxVideoSizeMB = 60; // 视频上限 60MB（放宽自 30MB，配合前端压缩）
        this.attachMaxImageSizeMB = 10; // 图片上限 10MB（放宽自 2MB，配合前端压缩）
        this.attachMaxImageCount = 10;
        this.attachMaxVideoCount = 3;
        this.attachShowOverlay = false;
        this.attachPreviewImg = '';
        this.attachPreviewMediaType = 'image';
        this.screenWidth = window.innerWidth * 0.9;
        this.screenHeight = window.innerHeight * 0.9;
        const that = this;
        this.formData = {
            deviceId: 0,
            description: '',
            device: '',
            hospital: null,
        };
        this.currentItem = {
            deviceId: 0,
            description: '',
        };
        this.menuDatePicker = {
            visible: false,
            date: '',
            events: [],
        };
        this.formDataMenu = {
            date: false,
            solveDate: false,
            expectedSolveDate: false,
        };
        this.editFormPanels = [];
        this.tableOptions = {
            visible: false,
            total: 0,
            pageSize: 10 /** 默认10条 */,
            page: 1,
            expanded: [],
        };
        this.searchOptions = {
            text: '',
            date: '',
            deviceType: null,
            device: null,
            status: '',
            single: false,
            statusList: null,
            dateRange: [new Date(new Date().setMonth(new Date().getMonth() - 1)).format('yyyy-MM-dd'), new Date().format('yyyy-MM-dd')],
        };
        this.dialogAlone = {
            description: '',
            reason: '',
            times: '',
            temporarySolution: '',
            finalSolution: '',
        };
        this.progressValue = 0;
        this.progressShow = false;
        this.exportDataMenu = ['台式西林设备', '台式安瓿设备', '综合配药设备'];
    }
    onExportFormMenuVisibleChg(visible) {
        if (!visible) {
            this.exportForm.deviceTypeGroup = null;
            this.exportForm.deviceType = '';
            this.exportForm.year = '';
        }
    }
    onAdvancedSearchChange() {
        this.$nextTick(() => {
            this.updatePageLayout();
        });
    }
    onPageLoadingChange() {
        this.$nextTick(() => {
            this.updatePageLayout();
        });
    }
    // 监听searchOptions发生变更（带防抖）
    onSearchOptionsChange() {
        if (this.searchTimer) {
            clearTimeout(this.searchTimer);
        }
        this.searchTimer = setTimeout(() => {
            this.refresh();
        }, 300);
    }
    async mounted() {
        const that = this;
        const rQuery = that.$router.currentRoute.query;
        if (rQuery && rQuery.device) {
            that.searchOptions.device = rQuery.device;
        }
        await that.fetchMalfunctionCatalog();
        await that.getMalfunctionStatus();
        await that.getHospitalList();
        await that.getDevices();
        await that.initUserList();
        that.refresh();
        window.addEventListener('resize', this.handleResize);
        this.$nextTick(() => {
            this.initPageLayoutObserver();
            requestAnimationFrame(() => {
                this.updatePageLayout();
            });
        });
    }
    beforeDestroy() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
            this.resizeObserver = null;
        }
        window.removeEventListener('resize', this.handleResize);
    }
    initPageLayoutObserver() {
        const parent = this.$refs.pageRef?.parentElement;
        if (!parent || typeof ResizeObserver === 'undefined') {
            return;
        }
        this.resizeObserver = new ResizeObserver(() => {
            this.updatePageLayout();
        });
        this.resizeObserver.observe(parent);
    }
    handleResize() {
        this.windowHeight = window.innerHeight;
        this.windowWidth = window.innerWidth;
        this.$nextTick(() => {
            this.updatePageLayout();
        });
    }
    updatePageLayout() {
        this.$nextTick(() => {
            this.calculateTableHeight();
        });
    }
    calculateTableHeight() {
        const contentAreaEl = this.$refs.contentAreaRef;
        if (!contentAreaEl) {
            return;
        }
        const contentAreaHeight = contentAreaEl.clientHeight;
        let paginationHeight = 0;
        if (this.$refs.paginationRef) {
            const paginationEl = this.$refs.paginationRef;
            paginationHeight = paginationEl.offsetHeight || 0;
        }
        const calculatedHeight = Math.max(100, contentAreaHeight - paginationHeight);
        this.tableHeight = calculatedHeight;
        if (this.$refs.tableContainerRef) {
            const tableContainerEl = this.$refs.tableContainerRef;
            tableContainerEl.style.height = `${calculatedHeight}px`;
        }
    }
    get headers() {
        const that = this;
        let h = [];
        h = h.concat([
            // { text: '明细id', value: 'id', width: 70, sortable: false },
            { text: '故障时间', align: 'left', width: 80, value: 'date', sortable: false },
            { text: '医院名称', value: 'hospitalName', width: 40, },
            { text: '医院负责人', value: 'hospitalManagerManager', width: 40, },
            { text: '设备类型', value: 'deviceType', width: 100, sortable: false },
            { text: '设备编号', value: 'deviceId', width: 100, },
            { text: '登记者', value: 'detectorName', width: 70, sortable: false },
            { text: '故障描述', value: 'description', width: 200 },
            { text: '次数', value: 'times', width: 60, sortable: false },
            { text: '故障原因', value: 'reason', width: 200 },
            { text: '解决办法', value: 'temporarySolution', width: 200 },
            { text: '状态', value: 'status', width: 95 },
        ], [
            {
                text: '操作',
                align: 'center',
                value: 'action',
                width: 110,
                sortable: false,
            },
        ]);
        return h;
    }
    get dynamicHeight() {
        return 'calc(100vh - 120px)';
    }
    get toolbarExtensionHeight() {
        return /^xs$|^sm$/i.test(this.$vuetify.breakpoint.name) ? 0 : 60;
    }
    resetSearch() {
        this.searchOptions = {
            text: '',
            date: '',
            deviceType: null,
            device: null,
            status: '',
            single: false,
            statusList: null,
            dateRange: [],
            registerCategory: [],
        };
    }
    get isAllExpanded() {
        const that = this;
        return that.list.length > 0 && that.tableOptions.expanded.length === that.list.length;
    }
    // 移动端判断（屏幕宽度小于768px为移动端）
    get isMobile() {
        return this.windowWidth < 768;
    }
    // 分页控件可见页码数量：根据屏幕宽度自适应，确保当前页附近可见
    get paginationTotalVisible() {
        if (this.windowWidth < 480) {
            return 5;
        }
        else if (this.windowWidth < 768) {
            return 7;
        }
        else if (this.windowWidth < 1024) {
            return 9;
        }
        else {
            return 11;
        }
    }
    expandedClick() {
    }
    async download() {
        // console.log('donwload btn click: ', JSON.stringify(this.searchOptions))
        const that = this;
        const stL = (that.searchOptions.statusList || []).length
            ? that.searchOptions.statusList
            : null;
        const daL = (that.searchOptions.dateRange || []).length
            ? that.searchOptions.dateRange
            : null;
        /** 默认需要进行日期限定 */
        const params = Object.assign({
            deviceType: that.searchOptions.deviceType,
            deviceId: that.searchOptions.device,
            status: that.searchOptions.status,
            date: that.searchOptions.date,
            text: that.searchOptions.text,
            category: that.searchOptions.category,
            module: that.searchOptions.module,
            manager: that.searchOptions.manager,
            detector: that.searchOptions.detector,
        }, stL ? { statusList: JSON.stringify(stL) } : {}, daL && daL.length == 2 ? { dateRange: JSON.stringify(daL) } : {}, daL && daL.length == 1 ? { date: daL[0] } : {});
        try {
            const result = await this.axios.post('/api/malfunctions/export', params);
            if (result) {
                if (!(result.data.data && result.data.data.length)) {
                    that.snackbar.warn('当前条件下没有可导出的数据');
                    return;
                }
                location.href = '/api/malfunctions/download?path=' + result.data.path;
            }
        }
        catch (e) {
            that.snackbar.error(`导出失败. ${(e && e.result) || ''}`);
        }
    }
    getList() {
        const that = this;
        that.tableLoading = true;
        that.pageLoading = true;
        try {
            const det = that.searchOptions.deviceType;
            const de = that.searchOptions.device;
            const st = that.searchOptions.status;
            const da = that.searchOptions.date;
            const tx = that.searchOptions.text;
            const ca = that.searchOptions.category;
            const mu = that.searchOptions.module;
            const ho = that.searchOptions.hospital;
            const rs = that.searchOptions.manager;
            const dt = that.searchOptions.detector;
            const rc = (that.searchOptions.registerCategory || []).length
                ? that.searchOptions.registerCategory
                : null;
            const stL = (that.searchOptions.statusList || []).length
                ? that.searchOptions.statusList
                : null;
            const daL = (that.searchOptions.dateRange || []).length
                ? that.searchOptions.dateRange
                : null;
            const ret = that.axios
                .get('/api/malfunctions', {
                params: Object.assign({
                    limit: that.tableOptions.pageSize,
                    page: that.tableOptions.page,
                }, det ? { deviceType: det } : {}, de ? (typeof de === 'object' ? { deviceId: de.deviceId } : { deviceNo: de }) : {}, st ? { status: st } : {}, da ? { date: da } : {}, tx ? { text: tx } : {}, ca ? { category: ca } : {}, mu ? { module: mu } : {}, ho ? { hospitalId: ho.id } : {}, stL ? { statusList: JSON.stringify(stL) } : {}, daL && daL.length == 2 ? { dateRange: JSON.stringify(daL) } : {}, daL && daL.length == 1 ? { date: daL[0] } : {}, rs ? { manager: rs } : {}, dt ? { detector: dt } : {}, rc ? { registerCategory: rc.join(',') || '' } : {}),
            })
                .then((res) => {
                that.pageLoading = false;
                that.list = (res && res.data && res.data.result) || [];
                /** 禅道任务【392】: 默认展开详细 */
                if (that.isExpanded) {
                    that.tableOptions.expanded = that.list;
                }
                that.tableOptions.total = (res && res.data && res.data.sum) || that.list.length;
                const category = res && res.data && res.data.category;
                if (category) {
                    that.listCategories = ['电气', '机械', '软件', '其它']
                        .concat(String(category.categories)
                        .split(',')
                        .filter((v) => v))
                        .filter((v, i, a) => v !== undefined
                        && v !== null
                        && String(v).length
                        && a.indexOf(v, 0) === i)
                        .sort((a, b) => a.localeCompare(b));
                    that.listModules = [
                        '电气',
                        '软件',
                        '卸料',
                        '转盘',
                        '输液袋',
                        '注射旋转',
                        '抽吸注射',
                        '其它',
                    ]
                        .concat(String(category.modules)
                        .split(',')
                        .filter((v) => v))
                        .filter((v, i, a) => v !== undefined
                        && v !== null
                        && String(v).length
                        && a.indexOf(v, 0) === i)
                        .sort((a, b) => a.localeCompare(b));
                    that.listDates = String(category.dates)
                        .split(',')
                        .filter((v, i, a) => v !== undefined
                        && v !== null
                        && String(v).length
                        && a.indexOf(v, 0) === i);
                }
                return res;
            })
                .catch((e) => {
                throw e;
            });
            that.tableLoading = false;
            return ret;
        }
        catch (e) {
            that.pageLoading = false;
            that.tableLoading = false;
            that.snackbar.error('数据加载失败，请尝试重新查询');
            throw e;
        }
    }
    // 刷新页面
    refresh() {
        const that = this;
        that.tableOptions.page = 1;
        clearTimeout(that.searchTimer);
        that.searchTimer = setTimeout(() => {
            that.getList();
        }, 1000); // 1秒执行一次获取函数 防抖   
    }
    handleInputChange(value) {
        const that = this;
        if (that.deviceSerialList && that.deviceSerialList.length) {
            const serialList = this.deviceSerialList.filter(v => value ? new RegExp(v.type, 'i').test(value) : true);
            const serialCode = serialList.filter(v => v.serial == that.exportForm.serial);
            if (!serialCode || !serialCode.length) {
                this.exportForm.serial = ''; // 清空
            }
        }
    }
    async exportData(value) {
        const that = this;
        try {
            // 使用分组导出功能，按deviceId+description分组统计故障次数
            // 作者: vacant, wq.chen@broadcare.com.cn
            const result = await that.axios.post('/api/malfunctions/export', {
                deviceType: that.exportForm.deviceType,
                serial: that.exportForm.serial,
                year: new Date().format(that.exportForm.year),
                type: 'grouped',
            });
            if (result) {
                if (!(result.data.data && result.data.data.length)) {
                    that.snackbar.warn('当前条件下没有可导出的数据');
                    return;
                }
                location.href = '/api/malfunctions/download?path=' + result.data.path;
            }
        }
        catch (e) {
            that.snackbar.error(`导出失败. ${(e && e.result) || ''}`);
        }
    }
    getDevices() {
        const that = this;
        return that.axios.get('/api/device', { params: {} }).then((res) => {
            that.listDevice = (res && res.data && res.data.result) || [];
            return res;
        });
    }
    getMalfunctionStatus() {
        const that = this;
        return that.axios
            .get('/api/malfunctions/status', { params: {} })
            .then((res) => {
            that.listStatus = (res && res.data && res.data.result) || [];
            return res;
        });
    }
    statusNameToObject(iname) {
        const it = this.listStatus.find((v) => v.name === iname);
        return it || { name: iname, color: 'lightgray', code: '', description: '' };
    }
    getStatusColor(iname) {
        const it = this.statusNameToObject(iname);
        return (it && it.color) || 'lightgray';
    }
    getDeviceItem(id, key) {
        const that = this;
        const it = that.listDevice.find((v) => v.id === id);
        return (it && it[key]) || '';
    }
    formatDateTime(dateStr) {
        if (!dateStr)
            return '';
        const date = new Date(dateStr);
        if (isNaN(date.getTime()))
            return dateStr;
        const year = date.getFullYear().toString().slice(-2);
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');
        return `${year}-${month}-${day}\n${hours}:${minutes}:${seconds}`;
    }
    toggleAllExpanded() {
        const that = this;
        if (that.isAllExpanded) {
            // 收起所有
            that.tableOptions.expanded = [];
            that.isExpanded = false;
        }
        else {
            // 展开所有
            that.tableOptions.expanded = [...that.list];
            that.isExpanded = true;
        }
    }
    getRowClass(item) {
        const index = this.list.indexOf(item);
        return index % 2 === 0 ? 'striped-even' : 'striped-odd';
    }
    onDialogHospitalChange() {
        const that = this;
        const currentDeviceId = that.formData.deviceId && that.formData.deviceId.id;
        that.formData.deviceId = null;
        if (currentDeviceId && that.formData.hospital) {
            const hospitalDevices = that.formData.hospital.devices || [];
            const hospitalDeviceIds = hospitalDevices.map((h) => String(h.deviceId || h.id));
            if (hospitalDeviceIds.includes(String(currentDeviceId))) {
                const device = that.listDevice.find((v) => v.id === currentDeviceId);
                if (device) {
                    that.formData.deviceId = device;
                }
            }
        }
    }
    get filteredDialogDevices() {
        const that = this;
        if (!that.formData.hospital) {
            return that.listDevice;
        }
        const hospital = that.formData.hospital;
        let hospitalDevices = [];
        if (hospital.devices && Array.isArray(hospital.devices)) {
            hospitalDevices = hospital.devices;
        }
        else if (hospital.deviceIds && Array.isArray(hospital.deviceIds)) {
            hospitalDevices = hospital.deviceIds.map((id) => ({ deviceId: id }));
        }
        else if (hospital.deviceList && Array.isArray(hospital.deviceList)) {
            hospitalDevices = hospital.deviceList;
        }
        if (!hospitalDevices.length) {
            console.warn('医院设备列表为空，返回所有设备', hospital);
            return that.listDevice;
        }
        const hospitalDeviceIds = hospitalDevices.map((h) => String(h.deviceId || h.id || h));
        console.log('医院设备ID列表:', hospitalDeviceIds);
        console.log('设备列表总数:', that.listDevice.length);
        const filtered = that.listDevice.filter((v) => hospitalDeviceIds.includes(String(v.id)));
        console.log('过滤后设备数量:', filtered.length);
        return filtered;
    }
    async getHospitalList() {
        const that = this;
        try {
            const ret = await that.axios.get('/api/hospital', {
                params: {
                    simple: false,
                    short: true
                }
            });
            that.listHospital = (ret && ret.data && ret.data.result || []).sort((a, b) => b.deviceCount - a.deviceCount);
            return ret;
        }
        catch (e) {
            console.error('获取医院列表失败:', e);
            throw e;
        }
    }
    createNew() {
        const that = this;
        that.editFormPanels = [];
        that.dialog.detail = false;
        that.dialog.status = false;
        that.dialog.editor = 1;
        that.dialog.title = '新增故障记录';
        that.dialog.text = '';
        that.formData = {
            detector: that.userInfo && that.userInfo.name,
            date: Vue.filter('dateFormat')(new Date(), 'yyyy-MM-dd'),
            hospital: null,
            failureCount: 1,
        };
        // 清空附件数据
        that.attachImageFile = null;
        that.attachPreviewList = [];
        that.attachIdList = [];
        that.dialog.visible = true;
    }
    handleStatusChange(value) {
        console.log('解决状态发生变化，新的值为:', value);
        // 执行你需要的操作
    }
    updateStatus(item, value) {
        const that = this;
        if (!/^undefined$|^null$|^\s?$/i.test(value)) {
            this.$set(item, 'status', value);
            /** 进行一次静默调用，避免刷新整个页面 */
            that.axios.put('/api/malfunctions/' + item.id, { status: value });
        }
    }
    handleBlur(item) {
        this.$set(item, 'isEditing', false);
        // console.log('---失去焦点')
        // item.isEditing = false;  // 失去焦点时关闭下拉框
    }
    getChipColor(item) {
        // 根据状态返回颜色
        const that = this;
        return this.getStatusColor(item.name);
    }
    handleChipClick(item) {
        // 处理点击小 chips 的事件
        console.log('小 chips 被点击:', item);
    }
    editItem(iItem, type) {
        const that = this;
        const item = JSON.parse(JSON.stringify(iItem));
        that.editFormPanels = [];
        that.dialog.editor = 2;
        that.dialog.status = type === 'status';
        that.dialog.detail = false;
        that.dialog.title = `修改故障${that.dialog.status ? '状态' : '记录'}`;
        that.dialog.text = '';
        that.formData = item;
        that.formData.deviceId = that.listDevice.find((v) => v.id === item.deviceId);
        // 设置医院信息
        if (item.hospitalId) {
            that.formData.hospital = that.listHospital.find((v) => v.id === item.hospitalId);
        }
        that.formData.category = (item.category && item.category.split().filter((v) => v)) || [];
        that.formData.responDepts = (item.responDepts
            && item.responDepts.split(',').filter((v) => v))
            || [];
        that.formData.module = (item.module && item.module.split().filter((v) => v)) || [];
        // 设置故障次数，如果没有则默认为 1
        // 后端字段是 times，前端使用 failureCount
        that.formData.failureCount = item.times || item.failureCount || 1;
        // 加载附件数据
        that.attachImageFile = null;
        that.attachPreviewList = [];
        that.attachIdList = [];
        const attachFiles = item.malfunctionsFiles || [];
        if (attachFiles && attachFiles.length) {
            attachFiles.forEach((f) => {
                // 仅使用 uploadFileId 访问；无上传记录的历史脏数据直接跳过
                if (f.uploadFileId == null)
                    return;
                const name = f.original || f.fileName || '';
                const previewType = that.inferAttachPreviewType(f.url || name, name);
                const url = that.buildAttachAccessUrl(f.uploadFileId);
                that.attachPreviewList.push({ url, previewType, name });
                that.attachIdList.push({
                    malFileId: f.id,
                    uploadFileId: f.uploadFileId,
                    url,
                    previewType,
                    name,
                    source: 'existing'
                });
            });
        }
        that.dialog.visible = true;
    }
    viewDetail(iItem) {
        const that = this;
        const item = JSON.parse(JSON.stringify(iItem));
        that.editFormPanels = [];
        that.dialog.editor = 4;
        that.dialog.status = false;
        that.dialog.detail = false;
        that.dialog.title = '故障详情';
        that.dialog.text = '';
        that.formData = item;
        that.formData.deviceId = that.listDevice.find((v) => v.id === item.deviceId);
        // 设置医院信息
        if (item.hospitalId) {
            that.formData.hospital = that.listHospital.find((v) => v.id === item.hospitalId);
        }
        that.formData.category = (item.category && item.category.split().filter((v) => v)) || [];
        that.formData.responDepts = (item.responDepts
            && item.responDepts.split(',').filter((v) => v))
            || [];
        that.formData.module = (item.module && item.module.split().filter((v) => v)) || [];
        that.formData.failureCount = item.times || item.failureCount || 1;
        // 加载附件数据
        that.attachImageFile = null;
        that.attachPreviewList = [];
        that.attachIdList = [];
        const attachFiles = item.malfunctionsFiles || [];
        if (attachFiles && attachFiles.length) {
            attachFiles.forEach((f) => {
                // 仅使用 uploadFileId 访问；无上传记录的历史脏数据直接跳过
                if (f.uploadFileId == null)
                    return;
                const name = f.original || f.fileName || '';
                const previewType = that.inferAttachPreviewType(f.url || name, name);
                const url = that.buildAttachAccessUrl(f.uploadFileId);
                that.attachPreviewList.push({ url, previewType, name });
                that.attachIdList.push({
                    malFileId: f.id,
                    uploadFileId: f.uploadFileId,
                    url,
                    previewType,
                    name,
                    source: 'existing'
                });
            });
        }
        that.dialog.visible = true;
    }
    deleteItem(iItem) {
        const that = this;
        const item = JSON.parse(JSON.stringify(iItem));
        that.dialog.editor = 3;
        that.dialog.status = false;
        that.dialog.detail = false;
        that.dialog.title = '故障记录删除';
        that.dialog.text = '是否删除当前故障记录，删除后将移至故障记录回收站.';
        that.formValid = true;
        that.formData = item;
        that.formData.deviceId = that.listDevice.find((v) => v.id === item.deviceId);
        that.formData.category = item.category && item.category.split();
        that.formData.module = item.module && item.module.split();
        that.dialog.visible = true;
    }
    async createNewHandle() {
        const that = this;
        const body = JSON.parse(JSON.stringify(that.formData));
        if (/object/i.test(typeof body['deviceId']))
            body['deviceId'] = body.deviceId.id;
        if (/object/i.test(typeof body['status']))
            body['status'] = body.status.name;
        if (/object/i.test(typeof body['hospital']))
            body['hospitalId'] = body.hospital.id;
        if (body.category instanceof Array)
            body.category = body.category.join();
        if (body.responDepts instanceof Array)
            body.responDepts = body.responDepts.join();
        if (body.module instanceof Array)
            body.module = body.module.join();
        // 将 failureCount 映射为 times（后端字段名）
        if (body['failureCount'] !== undefined) {
            body['times'] = body['failureCount'];
            delete body['failureCount'];
        }
        // 附件ID列表：新上传的 upload_files id，以及保留的已有 malfunction_files id
        const newAttachIds = (that.attachIdList || [])
            .filter((item) => item.source === 'new' && item.uploadFileId != null)
            .map((item) => item.uploadFileId);
        const keepAttachIds = (that.attachIdList || [])
            .filter((item) => item.source === 'existing' && item.malFileId != null)
            .map((item) => item.malFileId);
        body['newAttachIds'] = newAttachIds;
        body['keepAttachIds'] = keepAttachIds;
        // 移除不需要的字段
        delete body.hospital;
        delete body.malfunctionsFiles;
        const ret = await that.axios.post('/api/malfunctions', body);
        console.log('create result:', ret, ', body:', body);
        return ret;
    }
    editItemHandle() {
        const that = this;
        const form = JSON.parse(JSON.stringify(that.formData));
        let body = {};
        if (that.dialog.status) {
            body['status'] = form.status;
        }
        else {
            body = form;
            if (/object/i.test(typeof body['deviceId']))
                body['deviceId'] = body['deviceId'].id;
            if (/object/i.test(typeof body['status']))
                body['status'] = body['status'].name;
            if (/object/i.test(typeof body['hospital']))
                body['hospitalId'] = body['hospital'].id;
            if (body['category'] instanceof Array)
                body['category'] = body['category'].join();
            if (body['responDepts'] instanceof Array)
                body['responDepts'] = body['responDepts'].join();
            if (body['module'] instanceof Array)
                body['module'] = body['module'].join();
            // 将 failureCount 映射为 times（后端字段名）
            if (body['failureCount'] !== undefined) {
                body['times'] = body['failureCount'];
                delete body['failureCount'];
            }
            // 附件ID列表：新上传的 upload_files id，以及保留的已有 malfunction_files id
            const newAttachIds = (that.attachIdList || [])
                .filter((item) => item.source === 'new' && item.uploadFileId != null)
                .map((item) => item.uploadFileId);
            const keepAttachIds = (that.attachIdList || [])
                .filter((item) => item.source === 'existing' && item.malFileId != null)
                .map((item) => item.malFileId);
            body['newAttachIds'] = newAttachIds;
            body['keepAttachIds'] = keepAttachIds;
            // 移除不需要的字段
            delete body.hospital;
            delete body.malfunctionsFiles;
        }
        return that.axios.put('/api/malfunctions/' + that.formData.id, body);
    }
    deleteItemHandle() {
        const that = this;
        return that.axios.delete('/api/malfunctions/' + that.formData.id, {
            data: { ...that.formData },
        });
    }
    close() {
        const that = this;
        that.dialog.visible = false;
    }
    async save() {
        const that = this;
        const typeName = (that.dialog.editor === 1
            ? '新增'
            : that.dialog.editor === 2
                ? '修改'
                : '删除') + '故障信息';
        that.dialog.loading = true;
        // TODO: v-combobox(category)输入新内容后，随即点击提交按钮时数据未更新问题
        try {
            switch (that.dialog.editor) {
                case 1:
                    await that.createNewHandle();
                    break;
                case 2:
                    await that.editItemHandle();
                    break;
                case 3:
                    await that.deleteItemHandle();
                    break;
                default:
                    break;
            }
            that.dialog.loading = false;
            that.dialog.visible = false;
            that.getList();
            that.snackbar.success(`${typeName}成功`);
        }
        catch (e) {
            that.dialog.loading = false;
            if (that.dialog.editor === 3)
                that.dialog.visible = false;
            that.snackbar.error((e && (e.error || e.errorInfo || e.result || e.toString()))
                || `${typeName}失败`);
        }
    }
    openAlone(key, value, id) {
        const that = this;
        that.dialogAlone[key] = value;
        that.dialogAlone['id'] = id;
    }
    closeAlone() {
        const that = this;
        delete that.dialogAlone['description'];
        delete that.dialogAlone['reason'];
        delete that.dialogAlone['times'];
        delete that.dialogAlone['temporarySolution'];
        delete that.dialogAlone['finalSolution'];
        delete that.dialogAlone['id'];
    }
    async initUserList() {
        const that = this;
        that.userInfoDic.loading = true;
        const res = await that.axios.get('/api/users/');
        that.userInfoDic.list = [];
        if (res.data && res.data.result) {
            res.data.result.filter((o) => {
                if (o.usersInfo)
                    that.userInfoDic.list.push(o.usersInfo);
            });
        }
        that.userInfoDic.loading = false;
    }
    saveAlone(key, item) {
        const that = this;
        const curId = Number(that.dialogAlone.id);
        const curV = that.dialogAlone[key];
        const body = {};
        body[key] = curV;
        that.axios
            .put('/api/malfunctions/' + curId, body)
            .then((res) => {
            const keyName = key === 'description' ? '描述'
                : key === 'reason' ? '原因'
                    : key === 'times' ? '次数'
                        : key === 'temporarySolution' ? '临时解决方案'
                            : key === 'finalSolution' ? '最终解决方案'
                                : key;
            that.snackbar.success(`故障${keyName}修改成功.`);
            item[key] = curV;
        })
            .catch((e) => {
            that.snackbar.error('故障信息修改失败，请重试');
        });
    }
    paginationHandle() {
        const that = this;
        const ps = Number.isNaN(parseInt(that.tableOptions.pageSize, 10))
            ? that.tableOptions.total
            : that.tableOptions.pageSize;
        if (that.tableOptions.page > Math.ceil(that.tableOptions.total / ps))
            that.tableOptions.page = 1;
        that.getList();
    }
    // 移动端相关方法
    toggleMobileExpand(item) {
        // 确保响应式更新展开状态
        const currentState = item._expanded || false;
        this.$set(item, '_expanded', !currentState);
        // 强制更新视图
        this.$forceUpdate();
    }
    editField(item, field) {
        this.openAlone(field, item[field] || '', item.id);
    }
    openStatusMenu(item) {
        // 复用现有的状态编辑功能
        this.editItem(item, 'status');
    }
    // 判断是否为图片类型
    isImageType(file) {
        if (!file || !file.type)
            return false;
        return /^image\//i.test(file.type);
    }
    // 判断是否为视频类型
    isVideoType(file) {
        if (!file || !file.type)
            return false;
        return /^video\//i.test(file.type);
    }
    // 判断是否为允许的文件类型
    isAllowedAttachFile(file) {
        return this.isImageType(file) || this.isVideoType(file);
    }
    // 根据 url 或文件名推断预览类型（用于回显）
    inferAttachPreviewType(url, name) {
        let source = (name || url || '').toLowerCase();
        const keyIndex = source.indexOf('key=');
        if (keyIndex >= 0) {
            const keyPart = source.substring(keyIndex + 4);
            try {
                source = decodeURIComponent(keyPart);
            }
            catch (e) {
                source = keyPart;
            }
        }
        else {
            const qIndex = source.indexOf('?');
            if (qIndex >= 0)
                source = source.substring(0, qIndex);
        }
        if (/\.(mp4|webm|mov|avi|m4v)(\?|$)/i.test(source))
            return 'video';
        return 'image';
    }
    // 附件访问地址：统一走上传文件鉴权代理，不暴露真实目录
    buildAttachAccessUrl(uploadFileId) {
        if (uploadFileId == null || uploadFileId === '')
            return '';
        return `/api/upload/files/content/${uploadFileId}`;
    }
    // 解析附件访问地址（兼容旧调用）
    resolveAttachFileUrl(file) {
        if (!file)
            return '';
        return this.buildAttachAccessUrl(file.uploadFileId);
    }
    // 上传附件
    async submitAttach() {
        const that = this;
        if (!this.attachImageFile || !this.attachImageFile.length)
            return;
        const files = Array.isArray(this.attachImageFile) ? this.attachImageFile : [this.attachImageFile];
        try {
            // 先统计当前已有的图片和视频数量
            const currentImageCount = (that.attachIdList || []).filter((item) => item.previewType === 'image').length;
            const currentVideoCount = (that.attachIdList || []).filter((item) => item.previewType === 'video').length;
            for (const file of files) {
                if (!file || !(file instanceof File))
                    continue;
                if (!that.isAllowedAttachFile(file)) {
                    that.snackbar.warn(`不支持的文件类型：${file.name || file.type}，请上传图片或视频`);
                    continue;
                }
                const isImage = that.isImageType(file);
                const isVideo = that.isVideoType(file);
                if (isImage) {
                    // 检查图片数量限制
                    const newImageCount = (that.attachIdList || []).filter((item) => item.previewType === 'image').length;
                    if (newImageCount >= that.attachMaxImageCount) {
                        that.snackbar.warn(`图片最多只能上传 ${that.attachMaxImageCount} 张`);
                        continue;
                    }
                    // 前端压缩（browser-image-compression）
                    let uploadFile = file;
                    try {
                        that.snackbar.info(`正在压缩图片 ${file.name}...`);
                        const compressed = await compressImageFile(file);
                        // 压缩后体积反而更大（极少发生）则保留原图
                        if (compressed.size < file.size) {
                            uploadFile = compressed;
                            console.log(`[图片压缩] ${file.name} ${(file.size / 1024 / 1024).toFixed(2)}MB → ${(compressed.size / 1024 / 1024).toFixed(2)}MB`);
                        }
                        else {
                            console.log(`[图片压缩] ${file.name} 压缩后体积更大，跳过压缩`);
                        }
                    }
                    catch (e) {
                        console.warn(`[图片压缩] ${file.name} 压缩失败，降级使用原文件:`, e);
                    }
                    const fileSize = uploadFile.size / 1024 / 1024;
                    if (fileSize > that.attachMaxImageSizeMB) {
                        that.snackbar.warn(`图片大小不能超过 ${that.attachMaxImageSizeMB}MB：${file.name}`);
                        continue;
                    }
                    const formData = new FormData();
                    formData.append('image', uploadFile, uploadFile.name || file.name);
                    const res = await that.axios.post('/api/upload/files', formData, {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    });
                    const data = (res.data && res.data.result) || {};
                    const url = that.buildAttachAccessUrl(data.id);
                    that.attachPreviewList.push({ url, previewType: 'image', name: file.name });
                    that.attachIdList.push({ uploadFileId: data.id, url, previewType: 'image', name: file.name, source: 'new' });
                }
                else if (isVideo) {
                    // 检查视频数量限制
                    const newVideoCount = (that.attachIdList || []).filter((item) => item.previewType === 'video').length;
                    if (newVideoCount >= that.attachMaxVideoCount) {
                        that.snackbar.warn(`视频最多只能上传 ${that.attachMaxVideoCount} 个`);
                        continue;
                    }
                    const fileSize = file.size / 1024 / 1024;
                    if (fileSize > that.attachMaxVideoSizeMB) {
                        that.snackbar.warn(`视频大小不能超过 ${that.attachMaxVideoSizeMB}MB：${file.name}`);
                        continue;
                    }
                    const formData = new FormData();
                    formData.append('image', file);
                    const res = await that.axios.post('/api/upload/files', formData, {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    });
                    const data = (res.data && res.data.result) || {};
                    const url = that.buildAttachAccessUrl(data.id);
                    that.attachPreviewList.push({ url, previewType: 'video', name: file.name });
                    that.attachIdList.push({ uploadFileId: data.id, url, previewType: 'video', name: file.name, source: 'new' });
                }
            }
            that.attachImageFile = null;
        }
        catch (error) {
            that.attachImageFile = null;
            that.snackbar.error('上传失败', error);
        }
    }
    // 删除附件
    async deleteAttachImg(stepIndex) {
        const that = this;
        const item = (that.attachIdList || [])[stepIndex];
        if (!item) {
            that.attachPreviewList.splice(stepIndex, 1);
            that.attachIdList.splice(stepIndex, 1);
            return;
        }
        // 新上传的文件，调用上传文件删除接口
        if (item.source === 'new' && item.uploadFileId != null) {
            try {
                await that.axios.delete(`/api/upload/files/${item.uploadFileId}`);
            }
            catch (e) {
                console.warn('删除上传文件失败:', e);
            }
        }
        // 从列表中移除
        that.attachPreviewList.splice(stepIndex, 1);
        that.attachIdList.splice(stepIndex, 1);
        that.snackbar.success('已删除');
    }
    // 打开附件大图/视频预览
    openAttachOverlay(url, mediaType = 'image') {
        if (!url) {
            this.snackbar.warn('附件地址无效，无法预览');
            return;
        }
        this.attachPreviewImg = url;
        this.attachPreviewMediaType = mediaType;
        this.attachShowOverlay = true;
        if (mediaType === 'video') {
            this.$nextTick(() => {
                const videoEl = this.$refs.attachOverlayVideo;
                if (videoEl && typeof videoEl.play === 'function') {
                    const playPromise = videoEl.play();
                    if (playPromise && typeof playPromise.catch === 'function') {
                        playPromise.catch(() => {
                            // 自动播放被浏览器拦截时，用户可手动点播放
                        });
                    }
                }
            });
        }
    }
    // 关闭附件预览
    closeAttachOverlay() {
        const videoEl = this.$refs.attachOverlayVideo;
        if (videoEl && typeof videoEl.pause === 'function') {
            try {
                videoEl.pause();
                videoEl.currentTime = 0;
            }
            catch (e) {
                // ignore
            }
        }
        this.attachPreviewImg = '';
        this.attachPreviewMediaType = 'image';
        this.attachShowOverlay = false;
    }
};
__decorate([
    Getter
], DeviceLicense.prototype, "userInfo", void 0);
__decorate([
    Getter
], DeviceLicense.prototype, "deviceSerialList", void 0);
__decorate([
    Getter
], DeviceLicense.prototype, "deviceTypeList", void 0);
__decorate([
    Getter
], DeviceLicense.prototype, "malfunctionYears", void 0);
__decorate([
    Action
], DeviceLicense.prototype, "fetchMalfunctionCatalog", void 0);
__decorate([
    Action
], DeviceLicense.prototype, "fetchDeviceModeCatalog", void 0);
__decorate([
    Watch('exportForm.menuVisible')
], DeviceLicense.prototype, "onExportFormMenuVisibleChg", null);
__decorate([
    Watch('showAdvancedSearch')
], DeviceLicense.prototype, "onAdvancedSearchChange", null);
__decorate([
    Watch('pageLoading')
], DeviceLicense.prototype, "onPageLoadingChange", null);
__decorate([
    Watch('searchOptions', { deep: true })
], DeviceLicense.prototype, "onSearchOptionsChange", null);
__decorate([
    Watch('tableOptions.pageSize'),
    Watch('tableOptions.page')
], DeviceLicense.prototype, "paginationHandle", null);
DeviceLicense = __decorate([
    Component({
        name: 'Malfunction',
        components: {
            BcSnackbar,
            MalSearchOption,
        },
    })
], DeviceLicense);
export default DeviceLicense;
